import React, { useRef } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import oneLayer from '../../../img/oneLayer.png'
import arrowLeft from '../../../img/arrowLeft.png'
import arrowRight from '../../../img/arrowRight.png'
import SwiperCore, { A11y, Navigation, Pagination, Scrollbar } from 'swiper'
import 'swiper/components/navigation/navigation.scss'
import 'swiper/components/pagination/pagination.scss'
import 'swiper/components/scrollbar/scrollbar.scss'
import 'swiper/swiper.scss'
// import UserVideoComponent from '../UserVideoComponent/UserVideoComponent'

SwiperCore.use([Navigation, Pagination, Scrollbar, A11y])

export const UsersSlider = ({ publisher, subscribers, handleMainVideoStream }) => {
  const navigationPrevRef = useRef(null)
  const navigationNextRef = useRef(null)

  const newSubscribers = []

  for (let i = 0; i < Math.ceil(subscribers.length / 2); i++) {
    newSubscribers.push([subscribers[i * 2], subscribers[i * 2 + 1]])
  }

  return (
    <div className='sliderContainer'>
      <img src={arrowLeft} ref={navigationPrevRef} style={{ width: '80px' }} />
      <div className='slider'>
        <Swiper
          spaceBetween={100}
          slidesPerView={10}
          onInit={swiper => {
            swiper.params.navigation.prevEl = navigationPrevRef.current
            swiper.params.navigation.nextEl = navigationNextRef.current
            swiper.navigation.init()
            swiper.navigation.update()
          }}
          onSlideChange={() => {}}
          onSwiper={swiper => {}}
        >
          {newSubscribers.map(sub => (
            <SwiperSlide>
              {sub.map((e, i) => (
                <div key={i} className='stream-container' onClick={() => handleMainVideoStream(e)}>
                  {/* <UserVideoComponent streamManager={e} /> */}
                </div>
              ))}
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
      <img src={arrowRight} ref={navigationNextRef} style={{ width: '80px' }} />
    </div>
  )
}
